import type { ParagraphTranslations } from "../Paragraph.i18n";
import styles from "../Paragraph.module.css";

/**
 * VideoEmbed — iframe YouTube z aspect ratio 16:9.
 *
 * Backend (`IPARAGRAPH_CONTROLLER::processTwoColsTextVideoLayout` /
 * `processBigVideoLayout`) zwraca pełen URL embed
 * (`https://www.youtube.com/embed/{id}`). Tu tylko opakowujemy w `<iframe>`
 * z lazy loading + a11y.
 *
 * **Bezpieczeństwo:** referrerPolicy + allow restricts feature access. Sandbox
 * NIE jest tu używany bo blokowałby YouTube'owe controls (allowFullScreen,
 * autoplay).
 *
 * **Missing source:** gdy `src` jest pusty / nieprawidłowy — renderujemy
 * placeholder zamiast pustego iframe'a.
 */
export function VideoEmbed({
  src,
  title,
  t,
}: {
  src: string | null | undefined;
  title?: string | null;
  t: ParagraphTranslations;
}) {
  if (!src || typeof src !== "string" || !src.startsWith("http")) {
    return <div className={styles.videoMissing}>{t.video.missing}</div>;
  }

  return (
    <div className={styles.videoFrame}>
      <iframe
        src={src}
        title={title && title.length > 0 ? title : t.video.youtubeTitleFallback}
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
        allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      />
    </div>
  );
}
